// extracted by mini-css-extract-plugin
export default {"cls1":"SuggestedContentSidebar-cls1_Wsz","cls2":"SuggestedContentSidebar-cls2_rdO SuggestedContentSidebar-cls1_Wsz"};